import {
  BodyLinkV3,
  OuraSymbolIcon,
  TypographyV3,
  type TypographyV3Props,
} from '@jouzen/ecom-components';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';

const getValues = (options?: {
  li?: Omit<TypographyV3Props, 'children'>;
}): RichTranslationValues => {
  return {
    li: function li(chunks: ReactNode) {
      return (
        <TypographyV3
          variant="h5"
          Element="li"
          className="mb-2"
          {...options?.li}
        >
          {chunks}
        </TypographyV3>
      );
    },

    GfcuLink: function GfcuLink(chunks: ReactNode): JSX.Element {
      return (
        <BodyLinkV3 href="/guidelines-for-commercial-use">{chunks}</BodyLinkV3>
      );
    },
    symbol: function symbol(): JSX.Element {
      return <OuraSymbolIcon className="inline" />;
    },
  };
};

export default getValues;
